import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaEnvelope, FaPhone, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-white py-4 mt-5">
      <Container>
        <Row>
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="mb-3 d-flex align-items-center">
              <FaGraduationCap className="me-2" /> 
              Sistem Tugas Akhir
            </h5>
            <p className="text-muted">
              Platform terintegrasi untuk pengelolaan tugas akhir mahasiswa Program Studi Rekayasa Kosmetik Institut Teknologi Sumatera.
            </p>
          </Col>
          
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="mb-3">Tautan Cepat</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/dashboard" className="text-decoration-none text-muted">Dashboard</Link>
              </li>
              <li className="mb-2">
                <Link to="/pendaftaran-ta" className="text-decoration-none text-muted">Pendaftaran TA</Link>
              </li>
              <li className="mb-2">
                <Link to="/bimbingan" className="text-decoration-none text-muted">Bimbingan</Link>
              </li>
              <li className="mb-2">
                <Link to="/seminar" className="text-decoration-none text-muted">Seminar & Sidang</Link>
              </li>
            </ul>
          </Col>
          
          <Col md={4}>
            <h5 className="mb-3">Kontak</h5>
            <ul className="list-unstyled">
              <li className="mb-2 d-flex align-items-center">
                <FaMapMarkerAlt className="me-2 text-muted" />
                <span className="text-muted">Jl. Terusan Ryacudu, Way Hui, Kec. Jati Agung, Lampung Selatan</span>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaPhone className="me-2 text-muted" />
                <span className="text-muted">(0721) 8030188</span>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaEnvelope className="me-2 text-muted" />
                <span className="text-muted">info@itera.ac.id</span>
              </li>
            </ul>
            <div className="mt-3">
              <a href="https://www.facebook.com" className="text-muted me-3" target="_blank" rel="noopener noreferrer">
                <FaFacebook size={20} />
              </a>
              <a href="https://www.twitter.com" className="text-muted me-3" target="_blank" rel="noopener noreferrer">
                <FaTwitter size={20} />
              </a>
              <a href="https://www.instagram.com" className="text-muted" target="_blank" rel="noopener noreferrer">
                <FaInstagram size={20} />
              </a>
            </div>
          </Col>
        </Row>
        
        <hr className="my-4" />
        
        <div className="text-center text-muted">
          <small>&copy; {currentYear} Program Studi Rekayasa Kosmetik - Institut Teknologi Sumatera. All rights reserved.</small>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
